import React from 'react';
import { Link } from 'react-router-dom';

const CallToActionSection: React.FC = () => {
  return (
    <div className="container-fluid py-5" style={{ 
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background decorative elements */}
      <div className="position-absolute" style={{
        top: '-50px',
        right: '-50px',
        width: '200px',
        height: '200px',
        background: 'rgba(255,255,255,0.1)',
        borderRadius: '50%',
        zIndex: 1
      }}></div>
      <div className="position-absolute" style={{
        bottom: '-100px',
        left: '-100px',
        width: '300px',
        height: '300px',
        background: 'rgba(255,255,255,0.05)',
        borderRadius: '50%',
        zIndex: 1
      }}></div>
      
      <div className="container position-relative" style={{ zIndex: 2 }}>
        <div className="row justify-content-center text-center text-white">
          <div className="col-lg-10 col-xl-8">
            {/* Main CTA Content */}
            <div className="wow fadeInUp" data-wow-delay="0.1s">
              <h2 className="display-4 fw-bold mb-4">
                Ready to Transform Your Learning?
              </h2>
              <p className="fs-3 mb-2 fw-light">
                <span className="fw-bold">Test. Learn. Master.</span>
              </p>
              <p className="fs-5 mb-5 opacity-90">
                Join thousands of students who've accelerated their JEE and NEET preparation with AI-powered personalized learning. 
                Your smart study buddy is waiting to help you achieve your dreams.
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="row g-4 justify-content-center mb-5 wow fadeInUp" data-wow-delay="0.3s">
              <div className="col-md-6 col-lg-4">
                <Link 
                  to="/signup" 
                  className="btn btn-light btn-lg w-100 py-3 fw-bold shadow-lg"
                  style={{
                    borderRadius: '50px',
                    fontSize: '1.1rem',
                    transition: 'all 0.3s ease',
                    border: 'none'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-3px)';
                    e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                  }}>
                  <i className="fas fa-rocket me-2"></i>
                  Get Started for Free
                </Link>
              </div>
              <div className="col-md-6 col-lg-4">
                <Link 
                  to="/mock-test" 
                  className="btn btn-outline-light btn-lg w-100 py-3 fw-bold"
                  style={{
                    borderRadius: '50px',
                    fontSize: '1.1rem',
                    transition: 'all 0.3s ease',
                    borderWidth: '2px'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                    e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}>
                  <i className="fas fa-edit me-2"></i>
                  Take a Mock Test
                </Link>
              </div>
            </div>

            {/* Secondary CTA */}
            <div className="wow fadeInUp" data-wow-delay="0.5s">
              <p className="fs-6 mb-3 opacity-80">
                Want to experience our AI tutor first?
              </p>
              <Link 
                to="/ai-tutor" 
                className="btn btn-lg px-5 py-2"
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  border: '1px solid rgba(255,255,255,0.3)',
                  borderRadius: '30px',
                  color: 'white',
                  fontSize: '1rem',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.3)';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}>
                <i className="fas fa-comments me-2"></i>
                Talk to Wizi Now
              </Link>
            </div>
          </div>
        </div>

        {/* Achievement Stats */}
        {/* <div className="row justify-content-center mt-5 pt-4 wow fadeInUp" data-wow-delay="0.7s">
          <div className="col-lg-8">
            <div className="row text-center text-white">
              <div className="col-4">
                <div className="mb-2">
                  <i className="fas fa-users fa-2x mb-2 opacity-80"></i>
                  <h4 className="fw-bold mb-1">10,000+</h4>
                  <p className="small opacity-75 mb-0">Active Students</p>
                </div>
              </div>
              <div className="col-4">
                <div className="mb-2">
                  <i className="fas fa-trophy fa-2x mb-2 opacity-80"></i>
                  <h4 className="fw-bold mb-1">95%</h4>
                  <p className="small opacity-75 mb-0">Success Rate</p>
                </div>
              </div>
              <div className="col-4">
                <div className="mb-2">
                  <i className="fas fa-star fa-2x mb-2 opacity-80"></i>
                  <h4 className="fw-bold mb-1">4.9/5</h4>
                  <p className="small opacity-75 mb-0">Student Rating</p>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* Trust Indicators */}
        <div className="row justify-content-center mt-4 wow fadeInUp" data-wow-delay="0.9s">
          <div className="col-lg-6 text-center">
            <div className="d-flex align-items-center justify-content-center flex-wrap">
              <span className="badge bg-light text-dark me-3 mb-2 px-3 py-2 rounded-pill">
                <i className="fas fa-shield-alt me-1"></i>
                100% Secure
              </span>
              <span className="badge bg-light text-dark me-3 mb-2 px-3 py-2 rounded-pill">
                <i className="fas fa-mobile-alt me-1"></i>
                Mobile Friendly
              </span>
              <span className="badge bg-light text-dark mb-2 px-3 py-2 rounded-pill">
                <i className="fas fa-clock me-1"></i>
                24/7 Support
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToActionSection;
